import PropTypes from 'prop-types';

const defaultProps = {};

const propTypes = {
  city: PropTypes.string.isRequired,
};

export default function TrainerCity({ city }) {
  return (
    <div className="flex items-center space-x-1 pt-1">
      <svg
        className="w-4 h-4 fill-current text-gray-300"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
          clipRule="evenodd"
        />
      </svg>
      <div className="text-gray-500">{city}</div>
    </div>
  );
}

TrainerCity.defaultProps = defaultProps;
TrainerCity.propTypes = propTypes;
